import React from 'react';

import Image from '../../../components/image/Image';
import { ProjectDetails } from '../../../core/state/project/types';
import defaultUserImage from '../../../../img/user-default.png';

interface Props {
  project?: ProjectDetails;
}

const mainCls = 'project-details__info';

const ProjectDetailsContact: React.FC<Props> = ({ project }) => {
  return (
    <>
      {project?.projectContacts?.map((item) => (
        <div key={item.id} className={`${mainCls}-contact`}>
          <Image className={`${mainCls}-contact-img`} src={defaultUserImage} alt={item.firstName ?? ''} />
          <div className="d-flex flex-column">
            {`${item.firstName} ${item.lastName} ${item.title ? `(${item.title ?? ''})` : ''}`}
            {item.mobilePhoneNumber && <span className={`${mainCls}-contact-data`}>{`${item.mobilePhoneNumber}`}</span>}
          </div>
        </div>
      ))}
    </>
  );
};

export default ProjectDetailsContact;
